import {isRack, Packing, PackingType} from './packing.model';

export enum BinType {
  SERVICEABLE_FLOOR = 'SERVICEABLE_FLOOR',
  SERVICEABLE_RACK = 'SERVICEABLE_RACK',
  WORN_FLOOR = 'WORN_FLOOR',
  WORN_RACK = 'WORN_RACK',
  SPECIAL_WORN_FLOOR = 'SPECIAL_WORN_FLOOR'
}

export const formatBinType = (type?: BinType): string => {
  switch (type) {
    case BinType.SERVICEABLE_FLOOR:
    case BinType.SERVICEABLE_RACK:
      return 'MODELS.BINS.SERVICEABLE';
    case BinType.WORN_FLOOR:
    case BinType.WORN_RACK:
      return 'MODELS.BINS.WORN';
    case BinType.SPECIAL_WORN_FLOOR:
      return 'MODELS.BINS.SPECIAL_WORN';
    default:
      return type ? `MODELS.BINS.${type}` : '';
  }
};

export enum StackBinLevel {
  FULL = 'FULL',
  EMPTY = 'EMPTY',
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export enum MovableRackReference {
  TB = 'TB',
  CV = 'CV',
  PS = 'PS'
}

export enum LockMode {
  NO_LOCK = 'NO_LOCK',
  LOCKED_FOR_PICKING = 'LOCKED_FOR_PICKING',
  LOCKED_FOR_STORING = 'LOCKED_FOR_STORING',
  MANUAL_LOCKED = 'MANUAL_LOCKED'
}

export interface BinLocationLight {
  id: number;
  reference: string;
  type: BinType;
  packingType: PackingType;
  lockMode: LockMode;
  validationCode: string;
  maxCapacity: number;

  rackType: MovableRackReference | null;
  currentLevel: string;
  maxLevel: string;
  maxStackLevel?: StackBinLevel;
}

export interface BinLocation extends BinLocationLight {
  packings: Packing[];
}

export const getMaxBinSlot = (bin: BinLocation) => {
  if (isRack(bin.packingType)) {
    return bin.maxCapacity;
  } else {
    return convertStackLevelToInt(bin.maxLevel);
  }
};

export const convertStackLevelToInt = (stackLevel: string | StackBinLevel) => {
  const charCode = stackLevel?.toUpperCase().charCodeAt(0) ?? 0;
  return charCode - 64;
};

export const convertIntToStackLevel = (stackLevel: number) => {
  return String.fromCharCode(stackLevel + 64);
};

export interface BinSlot {
  reference: string;
  packing?: Packing;
}

export interface BinLocationRequest {
  type: BinType;
  validationCode: string;
  maxStackLevel?: StackBinLevel;
  locked: boolean | null;
  rackType?: MovableRackReference;
}
